import React, { useState, useEffect } from "react";
import logo from "../assest/Om-01.png"; // Make sure the path is correct

const questions = [
  { question: "What is the capital of France?", options: ["Berlin", "Madrid", "Paris", "London"], answer: "Paris" },
  { question: "Which planet is known as the Red Planet?", options: ["Earth", "Mars", "Jupiter", "Saturn"], answer: "Mars" },
  { question: "Who wrote 'Hamlet'?", options: ["Mark Twain", "William Shakespeare", "J.K. Rowling", "Ernest Hemingway"], answer: "William Shakespeare" },
  { question: "What is the largest mammal?", options: ["Elephant", "Blue Whale", "Giraffe", "Hippopotamus"], answer: "Blue Whale" },
  { question: "What gas do plants absorb?", options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Helium"], answer: "Carbon Dioxide" },
  { question: "What is the boiling point of water?", options: ["90°C", "100°C", "110°C", "120°C"], answer: "100°C" },
  { question: "What is the square root of 64?", options: ["6", "7", "8", "9"], answer: "8" },
  { question: "Which language is used for web apps?", options: ["Python", "Java", "JavaScript", "C++"], answer: "JavaScript" },
  { question: "How many continents are there?", options: ["5", "6", "7", "8"], answer: "7" },
  { question: "Which is the largest ocean?", options: ["Atlantic", "Indian", "Arctic", "Pacific"], answer: "Pacific" },
];

const App = () => {
  const [formData, setFormData] = useState({ name: "", email: "", contact: "" });
  const [showAssessment, setShowAssessment] = useState(false);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [timeLeft, setTimeLeft] = useState(15 * 60);

  useEffect(() => {
    if (showAssessment && timeLeft > 0 && !submitted) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    }
    if (timeLeft === 0 && !submitted) {
      handleSubmit(false);
    }
  }, [timeLeft, showAssessment, submitted]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setShowAssessment(true);
  };

  const handleAnswerSelect = (value) => {
    setAnswers({ ...answers, [currentQuestion]: value });
  };

  const handleNext = () => {
    if (answers[currentQuestion]) {
      if (currentQuestion < questions.length - 1) {
        setCurrentQuestion(currentQuestion + 1);
      } else {
        handleSubmit(true);
      }
    } else {
      alert("Please select an answer before proceeding.");
    }
  };

  const handleSubmit = (manual = true) => {
    if (manual && Object.keys(answers).length < questions.length) {
      alert("Please answer all questions before submitting.");
      return;
    }

    let correct = 0;
    questions.forEach((q, i) => {
      if (answers[i] === q.answer) correct++;
    });
    setScore(correct);
    setSubmitted(true);

    const details = questions.map((q, i) => (
      `Q${i + 1}: ${q.question}\nYour Answer: ${answers[i] || "Not Answered"}\nCorrect Answer: ${q.answer}\n`
    )).join("\n");

    const payload = {
      access_key: "8575db0a-d712-45bb-a231-82873de4c9bd",
      subject: "New Assessment",
      from_name: formData.name,
      email: formData.email,
      message: `Name: ${formData.name}\nEmail: ${formData.email}\nContact: ${formData.contact}\nScore: ${correct}/${questions.length}\n\n--- Assessment Answers ---\n${details}`,
    };

    fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => console.log("Email sent", data))
      .catch((err) => console.error("Email error", err));
  };

  return (
    <div style={{ backgroundColor: "#14121c", minHeight: "88vh", padding: "40px 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div style={{
        backgroundColor: "#fff",
        padding: "60px",
        maxWidth: "500px",
        width: "100%",
        borderRadius: "15px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}>
        {!showAssessment && !submitted && (
          <form onSubmit={handleFormSubmit}>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <img src={logo} alt="Logo" style={{ width: "250px" }} />
            </div>
            <h2 style={{ textAlign: "center" }}>Candidate Information</h2>
            <input
              type="text"
              placeholder="Name"
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              style={{ display: "block", marginBottom: "20px", width: "93%", padding: "14px" }}
            />
            <input
              type="email"
              placeholder="Email"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              style={{ display: "block", marginBottom: "20px", width: "93%", padding: "14px" }}
            />
            <input
              type="text"
              placeholder="Contact Number"
              required
              value={formData.contact}
              onChange={(e) => setFormData({ ...formData, contact: e.target.value })}
              style={{ display: "block", marginBottom: "20px", width: "93%", padding: "14px" }}
            />
            <button type="submit" style={{ padding: "12px 30px", float: "right" }}>Next</button>
          </form>
        )}

        {showAssessment && !submitted && (
          <div>
            <div style={{ textAlign: "right", fontWeight: "bold", color: timeLeft <= 60 ? "red" : "black" }}>
              Time Left: {String(Math.floor(timeLeft / 60)).padStart(2, "0")}:
              {String(timeLeft % 60).padStart(2, "0")}
            </div>

            <h2>Question {currentQuestion + 1} of {questions.length}</h2>
            <p style={{ fontWeight: "bold" }}>{questions[currentQuestion].question}</p>
            {questions[currentQuestion].options.map((opt, i) => (
              <label key={i} style={{ display: "block", marginBottom: "10px" }}>
                <input
                  type="radio"
                  name="option"
                  value={opt}
                  checked={answers[currentQuestion] === opt}
                  onChange={() => handleAnswerSelect(opt)}
                /> {opt}
              </label>
            ))}

            <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
    gap: "10px",
    marginRight: "20px",
  }}
>
  <button
    onClick={() => setCurrentQuestion(currentQuestion - 1)}
    disabled={currentQuestion === 0}
    style={{
      padding: "10px 20px",
      fontSize: "16px",
      backgroundColor: "#f0f0f0",
      color: "#000",
      border: "1px solid #999",
      cursor: currentQuestion === 0 ? "not-allowed" : "pointer",
      opacity: currentQuestion === 0 ? 0.6 : 1,
    }}
  >
    Prev
  </button>

  <button
    onClick={handleNext}
    style={{
      padding: "10px 20px",
      fontSize: "16px",
      backgroundColor: "#f0f0f0",
      color: "#000",
      border: "1px solid #999",
      cursor: "pointer",
    }}
  >
    {currentQuestion === questions.length - 1 ? "Finish" : "Next"}
  </button>
</div>

          </div>
        )}

        {submitted && (
          <div>
            <h2>Your exam has been successfully submitted Thank you.</h2>
            <p><strong>Name:</strong> {formData.name}</p>
            <p><strong>Email:</strong> {formData.email}</p>
            <p><strong>Contact:</strong> {formData.contact}</p>
            <p style={{ fontSize: "18px", fontWeight: "bold" }}>🎓 Your Score: {score}/{questions.length}</p>
            <h3>Review:</h3>
            {questions.map((q, i) => (
              <div key={i} style={{ marginBottom: "10px" }}>
                <p><strong>Q{i + 1}:</strong> {q.question}</p>
                <p>
                  Your Answer: <span style={{ color: answers[i] === q.answer ? "green" : "red" }}>
                    {answers[i] || "Not Answered"}
                  </span>
                </p>
                {answers[i] !== q.answer && (
                  <p style={{ color: "green" }}>Correct Answer: {q.answer}</p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default App;